module.exports = __webpack_public_path__ + "fonts/Circe-Regular.19bfaf42.woff2";